import { AccountPageAPIs } from '../utils/constants';
import { getData } from './service';

export const getAccountPageItems = async () => {
    const { data, error } = await getData(AccountPageAPIs.ACCOUNT);
    if (data) {
        return data;
    } else throw error;
};
